const DEFAULT_API_BASE = 'https://api.nk2telco.com.au';
const LOCAL_WORKER_BASE = 'http://localhost:8787';

const isBrowser = typeof window !== 'undefined';
const urlSearch = isBrowser ? new URL(window.location.href).searchParams : new URLSearchParams();
const isDemo = urlSearch.has('demo') || import.meta.env.DEV || (isBrowser && window.location.hostname === 'localhost');

export const API_BASE = isDemo ? LOCAL_WORKER_BASE : (import.meta.env.VITE_API_BASE || DEFAULT_API_BASE);

export const endpoints = {
  products: isDemo ? `${API_BASE}/api/demo/products` : `${API_BASE}/api/products`,
  product: (id: string) => (isDemo ? `${API_BASE}/api/products/${id}?demo` : `${API_BASE}/api/products/${id}`),
  checkout: `${API_BASE}/api/checkout`,
};

export const stripe = {
  publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'your-stripe-publishable-key',
};
